module.exports = __webpack_public_path__ + "static/07-1d4c7d22057cba5f6b25dc410e29aca6.png";